var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPowerAutomateScalable(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "pa_filter0_f"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.4,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "pa_filter1_f"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pa_paint0_linear",
    x1: 43,
    y1: 55,
    x2: 29,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D36A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1152D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pa_paint1_linear",
    x1: 46,
    y1: 10,
    x2: 46,
    y2: 86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84CAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#61B1FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pa_paint2_linear",
    x1: 37.5,
    y1: 10,
    x2: 37.5,
    y2: 86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B90F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A78EE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "pa_clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "pa_clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#pa_clip0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#pa_clip1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "pa_mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 10,
    width: 97,
    height: 76
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.2116 10C62.3496 10 63.4337 10.4847 64.1925 11.3328L94.6136 45.3328C95.9723 46.8514 95.9723 49.1486 94.6136 50.6672L64.1925 84.6672C63.4337 85.5153 62.3496 86 61.2116 86H3.94634C0.488777 86 -1.34012 81.9095 0.965366 79.3328L29 48L0.965366 16.6672C-1.34012 14.0905 0.488777 10 3.94634 10H61.2116Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#pa_mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63 10L29 48L-5 10H63Z",
    fill: "url(#pa_paint0_linear)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#pa_filter0_f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63 10.4L-5 86.4H63L97 48.4L63 10.4Z",
    fill: "black",
    fillOpacity: 0.24
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#pa_filter1_f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63 12L-5 88H63L97 50L63 12Z",
    fill: "black",
    fillOpacity: 0.32
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-5 86L63 10L97 48L63 86H-5Z",
    fill: "url(#pa_paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5 86L63 10L80 29L29 86H-5Z",
    fill: "url(#pa_paint2_linear)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerAutomateScalable);
export default __webpack_public_path__ + "static/media/PowerAutomate_scalable.2333a1b988fe0034f74a2bd8358464b5.svg";
export { ForwardRef as ReactComponent };